export default __webpack_public_path__ + "static/media/Christmas_15.056a13ea.png";